const countFieldErrors = (errors: unknown): number => {
    if (!errors || typeof errors !== 'object') return 0;
    if ('type' in errors) return 1;
    return Object.values(errors).reduce((count: number, value) => count + countFieldErrors(value), 0);
};

export default countFieldErrors;
